import { possibleTimezones } from "@nova/constants"
import { z, infer as ZodInfer } from "zod"

export const cognitoUserRecordSchema = z.object({
    id: z.string(),
    email: z.string(),
    givenName: z.string(),
    familyName: z.string(),
    phoneNumber: z.string().optional(),
    organizationName: z.string().optional(),
    title: z.string().optional(),
    defaultWorkspaceId: z.string().optional(),
    timezoneId: z.enum(possibleTimezones.map((t) => t.id)).optional(),
    profilePhotoS3Key: z
        .string()
        .regex(/^public\/user\/[\w-]+\/profile-photo\/[\w.-]+$/, {
            message: "Invalid S3 Key. Expected format: public/user/{userId}/profile-photo/{fileId}",
        })
        .optional(),
    gclid: z.string().optional(),
    utmSource: z.string().optional(),
    utmCampaign: z.string().optional(),
    utmMedium: z.string().optional(),
    utmTerm: z.string().optional(),
    createDate: z.string().optional(),
})

export const cognitoUserSchema = cognitoUserRecordSchema.extend({
    fullName: z.string(),
})

export type CognitoUserRecord = ZodInfer<typeof cognitoUserRecordSchema>
export type CognitoUser = ZodInfer<typeof cognitoUserSchema>
